import React, {useContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import CustomButton from "components/CustomButton";
import Popup from "components/WMS/Mobile/Popup";

// Assets
import RefreshIcon from "assets/img/wms/refresh-2-blue.svg";
import {MissionContext} from "../../context/MissionContext";

RefreshPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired
};

function RefreshPopup({open, handleClose, onClick}) {
    const {
        retailers,
        retailersToBeAddedToMission,
        setRetailersToBeAddedToMission,
        getWmsItemsByRetailer,
        getInTrolleyTotal,
        getCancelledTotal,
        loading,
        setLoading
    } = useContext(MissionContext)

    const Icon = () => (
        <img
            src={RefreshIcon}
            alt='Refresh'
            style={{
                width: '48px',
                height: '48px',
            }}
        />
    );

    function isRetailerInPicking (retailer) {
        const items = getWmsItemsByRetailer(retailer);
        const totalRetailerItems = items.length;
        const retailerItemsInTrolleyTotal = getInTrolleyTotal(items) + getCancelledTotal(items);

        return retailerItemsInTrolleyTotal < totalRetailerItems;
    }

    function handleValid () {
        if (retailersToBeAddedToMission.length === 0) {
            setRetailersToBeAddedToMission(retailers.filter(isRetailerInPicking).map(r => r.id))
        } else {
            onClick()
        }

        setLoading(true)
    }

    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id='wms.myPickingMissions.popup.refresh.title' />}
            subtitle={<FormattedMessage id='wms.myPickingMissions.popup.refresh.subtitle' />}
            icon={<Icon/>}
        >
            <Grid container>
                <Grid
                    container
                    item
                    direction={"column"}
                    gap={2}
                >
                    <CustomButton
                        onClick={() => handleValid()}
                        fullWidth={true}
                        loading={loading}
                        disabled={loading}
                    >
                        <FormattedMessage id='wms.myPickingMissions.popup.refresh.refresh' />
                    </CustomButton>
                    <CustomButton
                        onClick={handleClose}
                        color={'default'}
                        fullWidth={true}
                    >
                        <FormattedMessage id='wms.myPickingMissions.popup.refresh.cancel' />
                    </CustomButton>
                </Grid>
            </Grid>
        </Popup>
    )
}

export default RefreshPopup;
